import { defineComponent as _defineComponent } from 'vue'
import { withDefaults, computed } from "vue";

interface IRadios {
    value: string | number,
    labelBefore?: string,
    labelAfter?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseRadio',
  props: {
    value: null,
    radios: null,
    size: { default: 'medium' },
    name: null
  },
  emits: [
    'update:value',
],
  setup(__props: any, { emit: emits }) {

const props = __props as { value?: string | number | null, radios: IRadios[], size: 'large' | 'medium' | 'small', name?: string }

// @ts-ignore



const radioGroupName = computed(() => {
    return props.name || `base-radio-${Math.random().toString(36).substring(2, 11)}`;
});

const getClasses = computed<string>(() => {
    return [
        props.size && `is-${props.size}`,
    ];
});

const handleChange = (event: any) => {
    emits('update:value', event.target.value);
};

return { __sfc: true,props, emits, radioGroupName, getClasses, handleChange }
}

})